// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
import Honeybadger from "honeybadger-js";

//console.log('Vite ⚡️ Rails')


// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

//console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

//import '~/styles/application.scss'

import './setup_jquery';

import Turbolinks from "turbolinks";
import Rails from "rails-ujs";
import "~/vendor/cocoon";
import DataTable from 'datatables.net-dt'
import "babel-polyfill";
import "~/bindPolyfill";
import "whatwg-fetch";
import "~/giosg";
import "../helpers/load_i18n";


if (process.env.NODE_ENV === "production") {
  Honeybadger.configure({
    api_key: "570cad87",
    environment: '<%= ENV["ENVIRONMENT"] %>',
  });
}

Turbolinks.start();
if (!window.Rails) {
  Rails.start();
}

import "~/navigation";
import "~/flashMessages";
import "~/forestValuationPicker";
import "~/transferMessage";
import "~/analytics";
import "~/opKotiRequestConsent";
import floatingInput from "~/floatingInput";
import "~/consentForm";
import "~/supportButton";
import "~/accordion";
import "~/propertyNameUpdate";
import { loadComponents, unmountComponents } from "~/loadComponents.jsx";
import $ from "jquery";

$(document).on("turbolinks:before-visit", (event) => {
  if (window.interval) {
    clearInterval(window.interval);
  }
});

document.addEventListener("turbolinks:before-render", unmountComponents);

$(document).on("turbolinks:load", () => {
  loadComponents();
});

$(document).on("turbolinks:load", (event) => {
  // focus on flash message after page load so that the flash message is read out first by screen readers
  const flashMessage = document.querySelector("#flash-notification-content");
  if (flashMessage) {
    const originalContent = flashMessage.innerHTML;
    flashMessage.innerHTML = ""; // Clear the content briefly
    setTimeout(() => {
      flashMessage.innerHTML = originalContent; // Reset the content
      flashMessage.focus(); // Move focus to the flash message
    }, 0);
  }
  floatingInput();
  window.fbq && window.fbq("track", "PageView");

  // window.ga && window.ga('set', 'location', event.originalEvent.data.url)
  // window.ga && window.ga('send', 'pageview')

  $(document).on("change", "input[type='file']", (e) => {
    $(e.target).closest(".attachment-wrapper").css("background-image", "none");
    $(e.target)
      .closest(".attachment-wrapper")
      .addClass("attachment-wrapper--hidden");
  });

  $(
    "form#new_forest_valuation .insurance-selection__item, form#new_forest_valuation [data-role='validate-forest-id-format']"
  ).on("change keyup", (e) => {
    let validForestId = /^([0-9]+-){3}[0-9]+$/.test(
      $("[data-role='validate-forest-id-format']").val()
    );
    if ($("input:checked").length > 0 || validForestId) {
      $("input:submit").prop("disabled", false);
    } else {
      $(e.target).closest("input:submit").prop("disabled", true);
    }
  });

  $("[data-role='save-and-continue']").on("click tap", (e) => {
    e.preventDefault();
    $("#transaction_slip_draft").val("false");
    $(e.target).closest("form").submit();
  });

  $(document).on("change", ".file-upload input", (e) => {
    const input = e.target;
    const label = input.previousElementSibling;
    const labelVal = label.innerText;

    let fileName = e.target.value.split("\\").pop();

    if (fileName.length > 0) label.innerText = fileName;
    else label.innerText = labelVal;
  });

  $("#user_accepted_veromuistio_terms, #forest_valuation_accepted_terms").on(
    "change",
    (e) => {
      let checked = $(e.target).is(":checked");
      $(e.target)
        .closest("form")
        .find("input[type='submit']")
        .prop("disabled", !checked);
    }
  );

  var onPaymentPage = $("#submit-payment-form").length !== 0;
  if (onPaymentPage) {
    $("#submit-payment-form").click();
  }

  $("#lindorff_payment_application_type").on("change", (e) => {
    let value = e.target.value;
    switch (value) {
      case "inheritance":
        $(".customer_reference").removeClass("hidden");
        // $(".deceased_person_hetu").removeClass("hidden");
        // $(".customer_hetu").addClass("hidden");
        $(".customer_first_name").addClass("hidden");
        $(".customer_last_name").addClass("hidden");
        break;
      case "other_cession":
        $(".customer_reference").addClass("hidden");
        // $(".deceased_person_hetu").addClass("hidden");
        $(".customer_first_name").removeClass("hidden");
        $("label[for='lindorff_payment_customer_first_name']").text(
          "<%= I18n.t('activerecord.attributes.lindorff_payment.customer_first_name') %>"
        );
        $(".customer_last_name").removeClass("hidden");
        $("label[for='lindorff_payment_customer_last_name']").text(
          "<%= I18n.t('activerecord.attributes.lindorff_payment.customer_last_name') %>"
        );
        // $(".customer_hetu").removeClass("hidden");
        break;
      case "unbillable_collateral":
        $(".customer_reference").addClass("hidden");
        // $(".deceased_person_hetu").addClass("hidden");
        $(".customer_first_name").addClass("hidden");
        $(".customer_last_name").addClass("hidden");
        // $(".customer_hetu").addClass("hidden");
        break;
      case "billable_collateral":
        $(".customer_reference").addClass("hidden");
        // $(".deceased_person_hetu").addClass("hidden");
        $(".customer_first_name").removeClass("hidden");
        $("label[for='lindorff_payment_customer_first_name']").text(
          "Toimeksiantajan etunimi"
        );
        $(".customer_last_name").removeClass("hidden");
        $("label[for='lindorff_payment_customer_last_name']").text(
          "Toimeksiantajan sukunimi"
        );
        // $(".customer_hetu").removeClass("hidden");
        break;
      default:
        console.log("unhandled case");
    }
  });
});

document.addEventListener("turbolinks:before-cache", function () {
  floatingInput();
});

const patchPostMessageFunction = function () {
  var originalPostMessage = window.postMessage;

  var patchedPostMessage = function (message, targetOrigin, transfer) {
    originalPostMessage(message, targetOrigin, transfer);
  };

  patchedPostMessage.toString = function () {
    return String(Object.hasOwnProperty).replace(
      "hasOwnProperty",
      "postMessage"
    );
  };

  window.postMessage = patchedPostMessage;
};
patchPostMessageFunction();

window.triggerNativeAction = (data) => {
  whenPostMessageReady(() => {
    window.postMessage(JSON.stringify(data));
  });
};

window.whenPostMessageReady = (cb) => {
  if (window.postMessage.length === 1) {
    cb();
  } else {
    setTimeout(() => {
      whenPostMessageReady(cb);
    }, 50);
  }
};

window.isNative = () => $("body").hasClass("is-native");

$(function () {
  $("input[type='file']").on("change", (e) => {
    $(e.target).closest(".attachment-wrapper").css("background-image", "none");
    $(e.target)
      .closest(".attachment-wrapper")
      .addClass("attachment-wrapper--hidden");
  });

  $("[data-role='save-and-continue']").on("click tap", (e) => {
    e.preventDefault();
    $("#transaction_slip_draft").val("false");
    $(e.target).closest("form").submit();
  });

  if ($("body").hasClass("is-native")) {
    $(document).on("click", "[data-native-action]", (event) => {
      event.preventDefault();
      var target = $(event.currentTarget);
      var data = {
        action: target.data("nativeAction"),
        url: target.prop("href"),
        title: target.data("nativeTitle"),
        rightButtonUrl: target.data("nativeRightButtonUrl"),
      };
      triggerNativeAction(data);
    });
  }

  $("#transaction_slip_transactionable_attributes_category").on(
    "change",
    (e) => {
      let selectedValue = $(e.target).val();
      let vatLevel = $("#transaction_slip_vat_rate").data("defaultVatLevels")[
        selectedValue
        ];
      $("#transaction_slip_vat_rate").val(vatLevel);
    }
  );
});

$("#skip-to-main-content").on("click keydown", (e) => {
  if (e.type === "click" || (e.type === "keydown" && e.key === "Enter")) {
    e.preventDefault();
    window.location.href = $("#skip-to-main-content").attr("href");
  }
});


// Improve accessibility for our simple_form's custom checkboxes
$('.opux-input-checkbox input[type="checkbox"]').each((index, checkbox) => {
  const $checkbox = $(checkbox);
  const $label = $checkbox.closest('.opux-input-checkbox').find('label');

  if (!$label.length) return;

  const labelId = $label.attr('id') || `checkbox-${index + 1}-label`;
  $label.attr('id', labelId);
  $checkbox.attr('aria-labelledby', labelId);
});
